import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService.js";
import {RankingWidgetController} from "./controller";
import styles from './styles.scss';
import NumberAbbreviator from "../../../../core/utils/numberAbbreviator";

export default class RankingWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.animationTimeInMillisecond = 1000;
    this.componentId = props.componentId;
    this.controller = new RankingWidgetController(props.componentId, props.widget.legends, this.update);
    this.state = {
      legends: props.widget.legends
    };
  }

  componentDidMount() {
    this.container = d3.select(this.refs.container);
    WidgetService.addComponentToWidget(this.props.widget.id, this.controller);
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE, payload => this.handleResize(payload));
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, payload => this.handleResize(payload));
    this.subscribe(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, payload => this.handleLegendUpdate(payload));
  }

  componentWillUnmount() {
    this.unsubscribeAll();
    this.controller.destroy();
  }

  handleLegendUpdate(payload) {
    if (payload.widgetId === this.props.widget.id) {
      this.setState({legends: WidgetService.getWidget(this.props.widget.id).legends});
    }
  }

  update(data) {
    let sum = 0;
    data.forEach(d => sum += (d.y || 0));

    this.y = d3.scaleLinear()
      .domain([0, sum])
      .range([0, this.refs.container.clientHeight]);

    data.forEach((d, i) => {
      const block = $(this.refs['block-' + i]);
      const legend = this.state.legends.find(l => l.id === d.id);
      if (legend) {
        const legendElement = $(block.children()[0]);
        block.css({height: this.y(d.y) + "px", background: legend.parameters.legendColor});
        $(legendElement.children()[0]).text(legend.parameters.legendLabel);
        $(legendElement.children()[1]).text(NumberAbbreviator.format(d.y));
      }
    });


    this.latestData = data;
  }

  handleResize() {
    this.update(this.latestData);
  }

  render() {
    return (
      <div className={styles.container}>
        <div ref="container" style={{flex: 1, maxWidth: '100%'}}>
          {
            this.state.legends.map((l, i) => {
              const style = {height: 0};
              return <div className={styles.block} ref={'block-' + i}
                          style={style} key={i}>
                {/*<div style={{height: "100%", flex: 1}}/>*/}
                <div className={styles.legend}>
                  <div className={styles.label}/>
                  <div className={styles.value}/>
                </div>
                {/*<div*/}
                {/*style={{width: "15px", height: "15px", borderRadius: "15px", background: l.parameters.legendColor}}/>*/}
              </div>
            })
          }
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/ranking/rankingWidget.jsx